// extracted by mini-css-extract-plugin
module.exports = {"commentList":"CommentList_commentList__Nfz6w","comment":"CommentList_comment__1akWd","name":"CommentList_name__2ciic","text":"CommentList_text__2qDDB"};